// AYA Multiservice — couche service mock (aucun appel à un prestataire réel).
const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api/v3/multiservice`;

function clientId() {
  let v = localStorage.getItem("aya_client_id");
  if (!v) { v = Math.random().toString(36).slice(2, 12); localStorage.setItem("aya_client_id", v); }
  return v;
}

function headers() {
  const t = localStorage.getItem("civ_user_token");
  return { "Content-Type": "application/json", ...(t ? { Authorization: `Bearer ${t}` } : {}) };
}

const qs = (params = {}) => {
  const u = new URLSearchParams({ client_id: clientId(), ...params });
  return u.toString();
};

async function get(path, params) {
  const r = await fetch(`${API}${path}?${qs(params)}`, { headers: headers() });
  return r.json();
}

async function post(path, body) {
  const r = await fetch(`${API}${path}`, { method: "POST", headers: headers(), body: JSON.stringify({ client_id: clientId(), ...body }) });
  return r.json();
}

export const getCatalog = () => get("/catalog");
export const getOffers = (operator_id, category) => get("/offers", { operator_id, category });
export const createQuote = (payload) => post("/quote", payload);
export const createOrder = (payload) => post("/orders", payload);
export const confirmOrder = (orderId) => post(`/orders/${orderId}/confirm`, {});
export const getOrderStatus = (orderId) => get(`/orders/${orderId}`);
export const getOrderHistory = (params = {}) => get("/orders", params);

export const fmtFcfa = (n) => `${Number(n || 0).toLocaleString("fr-FR")} FCFA`;
export const newClientRef = () => `ms-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
